module.exports = __webpack_public_path__ + "static/media/cooler_fr.40d74156.png";